import React, { useEffect, useState } from "react";

import Markdown from 'react-markdown';
import Textarea from 'rc-textarea';

import styles from "./Entry.module.css";

import { deleteEntry, patchEntry } from "../../api/Api";
import { useMedia, useMediaUpdate } from "../../contexts/MediaContext";
import ErrorHandler from "../../helpers/ErrorHandler";


export const Entry = (props) => {

    // props:
    //
    // entryItem - object containing entry information
    // setEdited - state setter for edited entry

    // ----------------------------------------------------- STATE AND HOOKS

    const mediaItem = useMedia();
    const setMediaItem = useMediaUpdate();
    let token = localStorage.getItem("token");

    const prettyDateTime = makePrettyDate();
    const prettyBody = formatBody();

    const [isEditing, setIsEditing] = useState(false); // if entry is being edtied

    const [editingPage, setEditingPage] = useState(); // editing values
    const [editingTitle, setEditingTitle] = useState("");
    const [editingBody, setEditingBody] = useState("");
    const [editingReading, setEditingReading] = useState(null); // reading id 


    const [entryItem, setEntryItem] = useState(null);

    useEffect(() => {
        // runs on first render to create entry
        if (props.entryItem) {
            setEditingPage(props.entryItem.page);
            setEditingTitle(props.entryItem.title);
            setEditingBody(props.entryItem.body);

            setEntryItem(props.entryItem); // doest work without??

            // finds reading numer
            // if (mediaItem.currentReading !== null) {

            //     for (let i = 0; i < mediaItem.readings?.length; i++) {
            //         if (mediaItem.readings[i].readingid === mediaItem.currentReading) {
            //             // finds reading in book's list of readings
            //             setEditingReading(mediaItem.currentReading);
            //         }
            //     }
            // }

            setEditingReading(props.entryItem.readingid);
        }
    }, [props.entryItem])


    // ----------------------------------------------------- PRE-RENDER

    function makeDate(date) {
        // formats date in human readable way
        if (date === null || date === "") { // if reading in progress
            return "Present"
        }

        const temp = new Date(date)
        const converted = new Date(temp.getTime() - temp.getTimezoneOffset() * -60000).toLocaleString('en-us', { day: 'numeric', month: 'short', year: 'numeric' });

        return converted;
    }

    async function sendEdits() {
        // sends edits to the back
        let entryPatchModel = {};

        if (editingReading === null) { 
            // sets readingID to null if 0 was selected
            entryPatchModel = {
                usermediaid: mediaItem.usermediaid,
                title: editingTitle,
                body: editingBody,
                page: editingPage,
                readingid: 0
            }
        } else { 
            // defualt
            entryPatchModel = {
                usermediaid: mediaItem.usermediaid,
                title: editingTitle,
                body: editingBody,
                page: editingPage,
                readingid: editingReading
            }
        }

        await patchEntry(entryPatchModel, entryItem.entryid, token)
            .then((usermedia) => {
                setMediaItem(usermedia);
                setIsEditing(false); // turns off edit mode
            })
            .catch((error) =>{
                console.log("failed to patch entry", error);
                ErrorHandler(error);
            })
    }

    async function removeEntryFromDb() {
        // removes entry from db and sends info back to journal.js

        await deleteEntry(props.entryItem.entryid, mediaItem.usermedia, token)
            .then((usermedia) => {
                setMediaItem(usermedia);
                setIsEditing(false);
            })
            .catch((error) =>{
                console.log("failed to delete entry", error);
                ErrorHandler(error);
            })
    }

    const changePage = (event) => {
        // catches changes to page number
        setEditingPage(event.target.value);
    }

    const changeTitle = (event) => {
        // catches changes to title input
        setEditingTitle(event.target.value)
    }

    const changeBody = (event) => {
        // catches changes to body input
        setEditingBody(event.target.value);
    }

    function changeReading(readingid) {
        // catches changes to reading input
        setEditingReading(readingid);
    }

    function makePrettyDate() {
        // formats date dispaly
        
        const temp = new Date(props.entryItem.time)
        const converted = new Date(temp.getTime()).toLocaleString('en-us', { hour: 'numeric', minute: 'numeric', day: 'numeric', month: 'long', year: 'numeric' });

        return converted;
    }

    //adding white space to the boyd
    function formatBody() {

        if (props.entryItem.body === null) return null;

        let formattedBody = []
        let textPeices = props.entryItem.body.split('\n'); //splits review string by newlines
        for (let i = 0; i < textPeices.length; i++) {
            if (!textPeices[i]) { //if empty it means there was a blank line
                formattedBody.push(<div key={i} className={styles.spacer}></div>)
            } else {
                formattedBody.push(<Markdown key={i}>{textPeices[i]}</Markdown>) //adds string segment to array
            }
        }
        return formattedBody;
    }

    function removeEntry() {
        // props for a confirmation to removes entry

        if (window.confirm("Are you sure you want to delete this journal entry? This cannot be undone.")) {
            removeEntryFromDb(); // deletes entry
        }
    }

    // ----------------------------------------------------- RENDER

    return (
        <section className={styles.container}>
            {isEditing ?
                // EDITING CONTAINER
                <div className={styles.editingContainer}>
                    <div className={styles.inputGroup}>
                        <div className={styles.inputTitle}>Title</div>
                        <input className={styles.input} key="title input"
                            type="text"
                            value={editingTitle}
                            onChange={changeTitle} />
                    </div>
                    <div className={styles.pageAndReading}>
                        <div className={styles.inputGroup}>
                            <div className={styles.inputTitle}>Progress</div>
                            <input className={styles.input} key="page input"
                                type="number"
                                value={editingPage}
                                onChange={changePage}
                                max={mediaItem.type === "book" ? mediaItem.numpages : mediaItem.numEpisodes} />
                        </div>
                        {
                            mediaItem.readings !== null ?
                                <div className={styles.inputGroup}>
                                    <div className={styles.inputTitle}>Reading</div>
                                    <div className={styles.readings_container}>
                                        
                                        {mediaItem.readings.slice(0).reverse().map((reading, index) =>
                                            <div key={"reading" + index}
                                                onClick={() => changeReading(reading.readingid)}
                                                className={editingReading === reading.readingid ? styles.reading_selected : styles.reading_unselected}>
                                                <h3>{mediaItem.currentReading === reading.readingid ? "Current Reading" : `Reading: ${mediaItem.readings?.length - index}` }</h3>
                                                <span>Started on {makeDate(reading.dateStarted)}</span>
                                                {
                                                    reading.dateFinished !== null ?
                                                        <div>Ended on {makeDate(reading.dateFinished)}</div>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                        )
                                        }
                                        <div onClick={() => changeReading(null)}
                                            className={editingReading === 0 ? styles.reading_selected : styles.reading_unselected}>
                                            <h3>No Reading</h3>
                                            <span>Do not associate this entry with a reading</span>
                                        </div>

                                    </div>
                                </div>
                                :
                                <></>
                        }

                    </div>
                    <div className={styles.inputGroup}>
                        <div className={styles.inputTitle}>Body</div>
                        <Textarea className={styles.inputBody} key="body input"
                            autoSize={{ minRows: 10 }}
                            type="text"
                            value={editingBody}
                            onChange={changeBody} />
                    </div>
                    <div className={styles.buttonBar}>
                        <div className={styles.cancelAndDelete}>
                            <button type="submit" className={styles.cancelButton} onClick={() => setIsEditing(false)}>Cancel</button>
                            <button type="submit" className={styles.deleteButton} onClick={() => removeEntry()}>Delete</button>
                        </div>
                        <button type="submit" className={styles.submitButton} onClick={() => sendEdits()}>Save</button>
                    </div>
                </div>
                :
                // DISPLAY CONTAINER
                <div id="entry" className={styles.content}>
                    <div className={styles.entry_info_container}>
                        <div className={styles.titleContainer}>
                            <button className={styles.editButton} onClick={() => setIsEditing(!isEditing)}><img src="/assets/images/editIcon.svg"
                                className={styles.editButtonImage}
                                alt="Edit Icon" />
                            </button>
                            <h1 className={styles.title}>{props.entryItem.title}</h1>
                            
                        </div>
                        <div className={styles.time}> {prettyDateTime} </div>
                        <div className={styles.page}> Page {props.entryItem.page} </div>
                    </div>
                    <div className={styles.body}> {prettyBody} </div>
                </div>
            }
        </section>
    )
}